import { render, staticRenderFns } from "./upload_fileWork_copy2.vue?vue&type=template&id=35f1a926&"
import script from "./upload_fileWork_copy2.vue?vue&type=script&lang=js&"
export * from "./upload_fileWork_copy2.vue?vue&type=script&lang=js&"
import style0 from "./upload_fileWork_copy2.vue?vue&type=style&index=0&id=35f1a926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports